import { Pipe, PipeTransform, inject } from '@angular/core';
import { LocalizationDisplayService } from 'src/core/services/settings/localization-display.service';

/**
 * Renders a phone number with the tenant's Phone Number Format preference
 * (Administration &gt; Settings &gt; Localization):
 * `+90 532 123 45 67`, `0532 123 45 67` or `905321234567`.
 *
 * Empty input renders as `-`; input without digits (an extension label, for instance) is echoed
 * unchanged rather than mangled.
 *
 * ```html
 * {{ contact.phoneNumber | displayPhoneNumber }}
 * ```
 */
@Pipe({
  name: 'displayPhoneNumber',
  standalone: true,
  pure: false,
})
export class DisplayPhoneNumberPipe implements PipeTransform {
  private readonly localizationDisplay = inject(LocalizationDisplayService);

  private cachedInput: string | null | undefined;
  private cachedSettingsHash = '';
  private cachedResult = '';

  transform(value: string | null | undefined): string {
    const settingsHash = this.localizationDisplay.settingsHash;

    if (value === this.cachedInput && settingsHash === this.cachedSettingsHash) {
      return this.cachedResult;
    }

    this.cachedInput = value;
    this.cachedSettingsHash = settingsHash;
    this.cachedResult = this.localizationDisplay.formatPhoneNumber(value);

    return this.cachedResult;
  }
}
